export type SpecialtySelection = {
  includePhysicianSpecialties: boolean;
  includeFacilitySpecialties: boolean;
  includeRequiredSpecialties: boolean;
  includeInformationalSpecialties: boolean;
};

/**
 * A specialty selection maps to two orthogonal backend filter axes: entity type
 * (Physician / Facility) and requirement status (Required / Informational). Each axis is
 * applied as its own filter, so if both members of either axis are deselected that filter
 * yields zero specialties and the report returns no data. A selection is only valid when
 * both axes retain at least one member.
 */
export const isSpecialtySelectionValid = (s: SpecialtySelection): boolean =>
  (s.includePhysicianSpecialties || s.includeFacilitySpecialties) &&
  (s.includeRequiredSpecialties || s.includeInformationalSpecialties);
